import { render, staticRenderFns } from "./CoApplicantsEditor.vue?vue&type=template&id=5cffbe41"
import script from "./CoApplicantsEditor.vue?vue&type=script&lang=ts"
export * from "./CoApplicantsEditor.vue?vue&type=script&lang=ts"
import style0 from "./CoApplicantsEditor.vue?vue&type=style&index=0&id=5cffbe41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports